import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import {
  NominalLoyalty,
  RegularBenefitVariant,
} from '../../../../../../../typings'
import { messages } from './messages'

export function validationSuiteNominalLoyalty(intl: IntlShape) {
  return create(({ value, status, type }: NominalLoyalty) => {
    const { $t } = intl
    const { validation } = messages

    omitWhen(type !== RegularBenefitVariant.NominalLoyalty, () => {
      omitWhen(value === undefined, () => {
        test('value', $t(validation.greaterThan, { value: 0 }), () => {
          enforce(value).greaterThan(0)
        })
      })

      test('value', $t(validation.required), () => {
        enforce(value).isNotEmpty()
      })

      test('status', $t(validation.required), () => {
        enforce(status).isNotEmpty()
      })
    })
  })
}
